import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d96a572&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d96a572",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d96a572')) {
      api.createRecord('2d96a572', component.options)
    } else {
      api.reload('2d96a572', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d96a572&scoped=true&", function () {
      api.rerender('2d96a572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/goods/goodsAttribute/index.vue"
export default component.exports